<template>
    <vs-tabs class="unique_cstm_tab">
      <vs-tab label="Standard">
        <div class="con-tab-ejemplo">
          <question-listing
            questionApplicationType="General"
          ></question-listing>
        </div>
      </vs-tab>
      <!-- <vs-tab label="Custom"  v-if="!schoolAdmin">
        <div class="con-tab-ejemplo">
          <question-listing questionApplicationType="Custom"></question-listing>
        </div>
      </vs-tab>
      <vs-tab label="Shared"  v-if="!schoolAdmin">
        <div class="con-tab-ejemplo">
          <question-listing questionApplicationType="Shared"></question-listing>
        </div>
      </vs-tab> -->
    </vs-tabs>
</template>

<script>
import vSelect from 'vue-select'
import {
  fetchQuestionBank,
  deleteQuestionById,
  changeQuestionStatusById
} from '@/api/question-bank'
import Pagination from '@/components/common/pagination'
import { Subject } from '@/mixins/subject/subject'
import subjectListing from '@/views/pages/v1/lesson/subjectListing.vue'
import { Tag } from '@/mixins/tag/tag'
import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'
import QuestionListing from './components/QuestionListing.vue'

export default {
  components: {
    Pagination,
    subjectListing,
    vSelect,
    QuestionListing
  },
  data () {
    return {
      subject_id: [],
      selected: [],
      active1: '',
      active: false,
      select_filter_id: '',
      tableList: [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      question_details: [],
      meta: {
        total: '',
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ''
      },
      delete_id: []
    }
  },
  mixins: [Subject, Tag, PermissionMiddleware],
  mounted () {
    this.fetchTag((this.platform_module_id = 3))
    this.fetchSubjectList()
    // this.fetchQuestionBankList()
  },
  computed: {
    selectedLength () {
      if (this.selected.length > 1) {
        return true
      }
    }
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Question Bank')
    }
  },
  methods: {
    tagSearchWise () {
      this.subject_id = false
      this.fetchQuestionBankList()
    },
    filterBySubject (subject_id) {
      this.tagSearch = []
      this.subject_id = subject_id
      this.fetchQuestionBankList()
    },
    openEditView (question) {


      //setTimeout(function(){
      this.$router.push({
        name: 'QuestionsV2',
        params: { question_details: question }
      })
      //},3000)
    },

    async fetchQuestionBankList () {
      try {
        this.$vs.loading()

        const customerId = this.$store.getters.customerId
        const payload = {
          subject_id: this.subject_id
        }

        const { data } = await fetchQuestionBank(
          customerId,
          payload,
          this.meta.current_page
        )

        const question_details = data.data.question_details
        // this.question_details.forEach({

        // })

        this.question_details = data.data.question_details
        this.meta = data.data.meta


      } catch (error) {

      } finally {
        this.$vs.loading.close()
      }
    },
    deleteQuestion (id) {

    },
    openConfirm (id, singleQuestionObject) {

      if (singleQuestionObject.status === true) {
        this.$vs.notify({
          title: 'Error',
          text: 'Active question can not be deleted',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      } else {
        this.delete_id.length = 0
        this.delete_id[0] = id

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure you want to deleted this question?',
          accept: this.acceptAlert
        })
      }
    },

    acceptAlert () {
      this.questionDelete(this.delete_id)
    },

    bulkDelete () {
      let count = 0
      this.selected.forEach((ele) => {
        if (ele.status === true) {

          count = 1
        }
      })

      if (count === 1) {
        this.$vs.notify({
          title: 'Error',
          text: 'All the selected records should be deactivated first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are You Sure You want to deleted all this question?',
          accept: this.bulkAlertDelete
        })
      }


    },

    bulkAlertDelete () {
      this.delete_id = this.selected.map(function (ele) {
        return ele.id
      })


      this.questionDelete(this.delete_id)
    },

    async questionDelete (deleteid) {


      try {
        const customerId = this.$store.getters.customerId
        const payload = {
          ids: this.delete_id
        }
        const data = await deleteQuestionById(customerId, payload)

        // const deleteIndex = this.question_details.findIndex(element => element.id === id)

        // this.question_details.splice(deleteIndex, 1)

        this.$vs.notify({
          title: 'Success',
          text: 'Question is deleted from the question bank',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        for (const delete_id of this.delete_id) {
          for (let i = 0; i < this.question_details.length; i++) {
            //
            if (delete_id === this.question_details[i].id) {
              this.question_details.splice(i, 1)
              // break
            }
          }
        }
      } catch (e) {

      }
    },
    handlePageChange (page) {
      this.selected.length = 0
      this.meta.current_page = page


      // this.$router.replace({ path: '/pages/questionbanklist', query: {page:this.meta.current_page}  })

      this.fetchQuestionBankList()

    },
    async changeStatus (status, id, index) {

      try {
        this.$vs.loading()

        const customerId = this.$store.getters.customerId

        const objpayload = {
          ids: [id],
          status: !status
        }
        const data = await changeQuestionStatusById(customerId, objpayload)
        this.question_details[index].status = !status
        this.$vs.notify({
          title: 'Success',
          text: 'Status changed Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })

      } catch (error) {

        this.question_details[index].status = status
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}
</script>

<style>
.tag-holder {
  border: 1px solid grey;
  display: inline-flex;
  margin: 0 2px;
  padding: 2px 10px;
  border-radius: 5px;
}
.vuesax-app-is-ltr .vs-sidebar.vs-sidebar-position-right {
  z-index: 111111;
}
</style>
